import {newProjectCredential, updateProjectCredential, deleteProjectCredential} from "../../api";

export default {
    state: {},

    actions: {
        updateProjectCredential(context, credential) {
            let token = context.getters.getToken.jwt;

            return updateProjectCredential({token, credential});
        },

        newProjectCredential(context, credential) {
            let token = context.getters.getToken.jwt;

            return newProjectCredential({token, credential});
        },

        deleteProjectCredential(context, credential) {
            let token = context.getters.getToken.jwt;

            return deleteProjectCredential({token, credential});
        }
    },

    mutations: {},

    getters: {}
}